// extracted by mini-css-extract-plugin
export default {"advertDetailService__label":"c-m_hr","advertDetailService__price":"c-m_hs"};